import { render, staticRenderFns } from "./creditDetails.vue?vue&type=template&id=33bbf020&scoped=true&"
import script from "./creditDetails.vue?vue&type=script&lang=js&"
export * from "./creditDetails.vue?vue&type=script&lang=js&"
import style0 from "./creditDetails.vue?vue&type=style&index=0&id=33bbf020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbf020",
  null
  
)

export default component.exports